import React, { useState } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import Button from "legacy/components/shared/Button"
import { Element } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { Maybe } from "types/Maybe"
import NavigationTrigger from "./NavigationTrigger"
import { PrismicNavigationDataBodyTopLevelItem } from "types/__generated__/gatsby-graphql"
import SubMenu from "./SubMenu"

interface OwnProps {
  navItems: Maybe<PrismicNavigationDataBodyTopLevelItem>[]
}

export type NavigationProps = OwnProps

const Navigation: React.FC<NavigationProps> = ({
  navItems,
}): React.ReactElement | null => {
  if (!navItems) return null
  const { t } = useTranslation("shared", {
    keyPrefix: "navigation",
  })

  const [navOpen, setNavOpen] = useState(false)
  const [openSubMenu, setOpenSubMenu] = useState<string>()

  const handleNavs = function (openedNav: string): void {
    setOpenSubMenu(openedNav)
  }

  const setMaxHeight = function (navIsOpen: boolean): Array<string | number> {
    if (navIsOpen) {
      return ["100vh", "100vh", "100vh", "100%"]
    }

    return [0, 0, 0, "100%"]
  }

  const addAnalytics = (): void => {
    analytics.track("Download Button Clicked")
  }

  return (
    <>
      <NavigationTrigger open={navOpen} setOpen={setNavOpen} />
      <Element
        alignItems={["left", "left", "left", "center"]}
        bg="white"
        display="flex"
        flexDirection={["column", "column", "column", "row"]}
        height={["auto", "auto", "auto", "100%"]}
        justifyContent={["flex-start", "flex-start", "flex-start", "flex-end"]}
        left="0"
        maxHeight={setMaxHeight(navOpen)}
        overflow={["hidden", "hidden", "hidden", "visible"]}
        position={["absolute", "absolute", "absolute", "relative"]}
        px={["30", "30", "30", "0"]}
        right="0"
        top={["45", "70", "70", "0"]}
        transition="all 0.5s ease"
        zIndex={1}
      >
        {navItems?.map((subMenu, index) => {
          const key = `submenu_${index}`
          return (
            <SubMenu
              key={key}
              menuId={key}
              openSubMenu={openSubMenu}
              setOpenSubMenu={handleNavs}
              subMenu={subMenu}
            />
          )
        })}
        <Element as="a" mr="20" href="/app/">
          <Button
            fontSize="13"
            fontWeight="regular"
            my={["20", "30", "30", 0]}
            onClick={addAnalytics}
            px="12px"
            py="8px"
          >
            {t("book_now")}
          </Button>
        </Element>
        <Link
          fontWeight="bold"
          mb={["20", "30", "30", 0]}
          to="/donor-assessment/"
          variant="navLink"
          width={["100%", "100%", "100%", "auto"]}
        >
          {t("take_quiz")}
        </Link>
      </Element>
    </>
  )
}

export default Navigation
